import MiniCalendar from "components/calendar/MiniCalendar";
import WeeklyRevenue from "views/admin/default/components/WeeklyRevenue";
import TotalSpent from "views/admin/default/components/TotalSpent";
import PieChartCard from "views/admin/default/components/PieChartCard";
import { IoMdHome } from "react-icons/io";
import { IoDocuments } from "react-icons/io5";
import { MdBarChart, MdDashboard, MdSupervisorAccount } from "react-icons/md";

import { columnsDataCheck, columnsDataComplex } from "./variables/columnsData";

import Widget from "components/widget/Widget";
import CheckTable from "views/admin/default/components/CheckTable";
import ComplexTable from "views/admin/default/components/ComplexTable";
import DailyTraffic from "views/admin/default/components/DailyTraffic";
import TaskCard from "views/admin/default/components/TaskCard";
import tableDataCheck from "./variables/tableDataCheck.json";
import tableDataComplex from "./variables/tableDataComplex.json";
import { useEffect, useState } from "react";
import DashboardService from "services/dashboard.service";
import moment from "moment";
import { FaUser } from "react-icons/fa";
import Loader from "../../../assets/img/loader.gif";
import { RiVerifiedBadgeFill } from "react-icons/ri";
import DateRangePicker from "components/fields/DateRangePicker";
import { useNavigate } from "react-router-dom";

// Module-level tabCache for persistent data across component mounts/unmounts
const tabCache = {
  dashboard: {
    data: null,
    firstLoad: true,
  },
};

const Dashboard = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [value, setValue] = useState({
    startDate: "",
    endDate: "",
    // startDate: new Date(new Date().setMonth(new Date().getMonth() - 1)),
    // endDate: new Date(),
  });

  const getDashboardDetails = async (showLoader = true) => {
    try {
      let response = null;
      if (showLoader) {
        setLoader(true);
      }
      const body = {
        startDate: value.startDate
          ? moment(value.startDate).startOf("day").format()
          : null, // Set your specific start date
        endDate: value.endDate
          ? moment(value.endDate).endOf("day").format()
          : null, // Set your specific end date
      };
      if (value.startDate && value.endDate) {
        response = await DashboardService.dateFilterForAll(body);
      } else {
        response = await DashboardService.getDashboard();
      }
      
      const responseData = response.data.data;
      
      // Update cache
      tabCache.dashboard.data = responseData;
      
      // Set firstLoad to false after successful fetch
      if (tabCache.dashboard.firstLoad) {
        tabCache.dashboard.firstLoad = false;
      }
      
      setData(responseData);
    } catch (error) {
      console.log("🚀 ~ getDashboardDetails ~ error:", error);
    } finally {
      if (showLoader) {
        setLoader(false);
      }
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    // Check cache first
    const cache = tabCache.dashboard;
    
    // If cached data exists, show it instantly
    if (cache.data) {
      setData(cache.data);
    }
    
    // Always fetch fresh data in background
    // Show loader only on firstLoad (when no cache exists yet)
    const shouldShowLoader = cache.firstLoad && !cache.data;
    getDashboardDetails(shouldShowLoader);
  }, [value]);

  const handleNavigatePages = (url, type) => {
    // Build query parameters if dates are selected
    const params = new URLSearchParams();
    if (value.startDate) {
      params.append("startDate", moment(value.startDate).format("YYYY-MM-DD"));
    }
    if (value.endDate) {
      params.append("endDate", moment(value.endDate).format("YYYY-MM-DD"));
    }
    
    // Append query string to URL if dates exist
    const queryString = params.toString();
    const finalUrl = queryString ? `${url}?${queryString}` : url;
    
    navigate(finalUrl);
    localStorage.setItem("type", type);
  };

  return (
    <div className="m-auto h-full min-h-[calc(100vh-212px)]">
      {loader && tabCache.dashboard?.firstLoad && !tabCache.dashboard?.data ? (
       <div 
       className="fixed" 
       style={{ 
         top: '50vh', 
         left: '57vw', 
         transform: 'translate(-50%, -50%)', 
         zIndex: 40,
         margin: 0,
         padding: 0,
         width: 'auto',
         height: 'auto'
       }}
     >
          <img
            src={Loader}
            alt="Loading..."
            className="h-16 w-16 block"
            style={{ margin: '0 auto', padding: 0, display: 'block' }}
          />
        </div>
      ) : (
        <>
          <div className="my-5 flex w-[280px] justify-start ml-1">
            <DateRangePicker
              value={value}
              onChange={(newValue) => setValue(newValue)}
              showShortcuts={true}
              classNames="w-fit"
              popupAlign="left"
            />
          </div>

          <div className="mt-3 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-3 3xl:grid-cols-5">
            <Widget
              onClick={() => handleNavigatePages("/users")}
              icon={<MdBarChart className="h-7 w-7" />}
              title={"Total Users"}
              subtitle={data?.totalUsers}
            />
            {/* <Widget
              onClick={() => handleNavigatePages("/account-verification")}
              icon={<IoDocuments className="h-6 w-6" />}
              title={"Total Accounts"}
              subtitle={data?.totalPages}
            /> */}
            <Widget
              onClick={() =>
                handleNavigatePages("/account-verification", "personal")
              }
              icon={<FaUser className="h-7 w-7" />}
              title={"Total Personal Accounts"}
              subtitle={data?.totalPersonalAccounts}
            />
            <Widget
              onClick={() =>
                handleNavigatePages("/account-verification", "page")
              }
              icon={<IoDocuments className="h-6 w-6" />}
              title={" Total Pages"}
              subtitle={data?.totalPages}
            />
            <Widget
              onClick={() =>
                handleNavigatePages("/account-verification", "community")
              }
              icon={<MdSupervisorAccount className="h-6 w-6" />}
              title={"Total Communities"}
              subtitle={data?.totalCommunityAccounts}
            />
            {/* <Widget
              onClick={() => handleNavigatePages("/account-verification", "verified")}
              icon={<RiVerifiedBadgeFill className="h-7 w-7" />}
              title={"Verified pages"}
              subtitle={data?.totalVerifyBadge}
            /> */}
          </div>
        </>
      )}
    </div>
  );
};

export default Dashboard;
